"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const column_1 = require("./column");
const keautils_1 = require("keautils");
const drillDowns_1 = require("../simpleGrid/drillDowns");
const keautils_2 = require("keautils");
function gridColumnToHeader(x) {
    return (x.render == null ? (props) => React.createElement(column_1.GridColumnComponent, Object.assign({}, props, { titulo: x.title })) :
        x.render);
}
exports.gridColumnToHeader = gridColumnToHeader;
let x = {};
class GridHeaderComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.onChangeSelector = (props) => props.onChange;
        this.valueSelector = (props) => props.value;
        this.filtroOrdenSelector = keautils_1.createDeepSelector(this.valueSelector, value => value.filtroOrden);
        this.onFiltroOrdenChangeSelector = keautils_1.createDeepSelector(this.onChangeSelector, this.valueSelector, (onChange, value) => (filtroOrden) => onChange(Object.assign({}, value, { filtroOrden })));
        this.onColumnaChangeSelector = keautils_1.createDeepSelector(this.onFiltroOrdenChangeSelector, this.filtroOrdenSelector, (onChange, value) => (columna) => onChange(Object.assign({}, value, { columna: columna })));
        this.onOrdenChangeSelector = keautils_1.createDeepSelector(this.onFiltroOrdenChangeSelector, this.filtroOrdenSelector, (onChange, value) => (orden) => onChange(Object.assign({}, value, { orden })));
        this.ordenSelector = keautils_1.createDeepSelector(this.filtroOrdenSelector, x => x.orden);
        this.filtrosColumnaSelector = keautils_1.createDeepSelector(this.filtroOrdenSelector, x => x.columna);
        this.estaFiltradaSelector = keautils_1.createSelector(this.filtrosColumnaSelector, filtros => (i) => {
            const next = { filtros };
            const diff = keautils_1.shallowDiff(x, next);
            x = next;
            return filtros[i] != null;
        });
        this.getOrdenColumnaSelector = keautils_1.createSelector(this.ordenSelector, orden => (i) => {
            return (orden && orden.columna == i) ? orden.orden : undefined;
        });
        this.onQuitarColumnMappingSelector = keautils_1.createDeepSelector(this.onChangeSelector, this.valueSelector, (onChange, value) => (index) => onChange(Object.assign({}, value, { mapping: (value.mapping || []).filter(x => x != index) })));
        this.onQuitarColumna = (index) => {
            const newValue = drillDowns_1.quitarColumna(index, this.valueSelector(this.props));
            this.props.onChange(newValue);
        };
        this.columnasSelector = (props) => props.columnas;
        this.mappingOrig = (props) => props.value.mapping;
        this.mappingSelector = keautils_1.createDeepSelector(this.mappingOrig, x => x);
        /**Columnas ordenadas con el orden establecido por el usuario */
        this.columnasOrdenadasSelector = keautils_1.createSelector(this.columnasSelector, this.mappingSelector, (columnas, mapping) => {
            return mapping.map(i => ({ key: i, columna: columnas[i] }));
        });
        this.puedeQuitar = (props) => props.puedeQuitar;
        this.columnasComponentSelector = keautils_1.createSelector(this.columnasOrdenadasSelector, this.estaFiltradaSelector, this.getOrdenColumnaSelector, this.puedeQuitar, (columnas, estaFiltrada, getOrdenColumna, puedeQuitar) => {
            return columnas
                .map(col => ({
                render: col.columna,
                props: {
                    key: col.key,
                    puedeOrdenar: true,
                    estaFiltrado: estaFiltrada(col.key),
                    onFiltrar: () => this.onFiltrar(col.key),
                    onOrdenar: () => this.onOrdenar(col.key),
                    orden: getOrdenColumna(col.key),
                    puedeQuitarOriginal: puedeQuitar,
                    esDrillDown: drillDowns_1.isDrilldownColumn(col.key),
                    onQuitar: () => this.onQuitarColumna(col.key),
                }
            }))
                .map(col => col.render(col.props));
        });
        this.onFiltrar = (index) => {
            const filtros = this.filtrosColumnaSelector(this.props);
            const existe = filtros[index] != null;
            let nuevo;
            if (existe) {
                //Quitar el filtro:
                nuevo = keautils_2.omit(filtros, [index]);
            }
            else {
                //Poner el filtro, iniciamos con los datos del filtro como indefinidos
                nuevo = Object.assign({}, filtros, { [index]: { datos: undefined } });
            }
            this.onColumnaChangeSelector(this.props)(nuevo);
        };
        this.onOrdenar = (index) => {
            const orden = this.ordenSelector(this.props);
            let nuevaDireccion;
            if (orden == undefined || orden.columna != index) {
                nuevaDireccion = "asc";
            }
            else if (orden.orden == "asc") {
                nuevaDireccion = "desc";
            }
            else {
                nuevaDireccion = undefined;
            }
            const nuevoOrden = nuevaDireccion ? { columna: index, orden: nuevaDireccion } : undefined;
            this.onOrdenChangeSelector(this.props)(nuevoOrden);
        };
    }
    render() {
        const estaFiltrada = this.estaFiltradaSelector(this.props);
        const ordenColumna = this.getOrdenColumnaSelector(this.props);
        return (React.createElement("tr", null, this.columnasComponentSelector(this.props)));
    }
}
exports.GridHeaderComponent = GridHeaderComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/header.js
// module id = 2223
// module chunks = 0